import { intl } from './intl';

export const { t: videoUploadT, Message: VideoUploadMessage } = intl.createMessages({
    dragAndDropSingle: {
        ru: 'или перетащите сюда файл',
        en: 'or drag and drop a file here',
    },
    dragAndDropMultiple: {
        ru: 'или перетащите сюда один или несколько файлов, либо скопируйте файлы и вставьте через {shortcut}',
        en: 'or drag and drop one or more files here, or copy files and paste them with {shortcut}',
    },
    dragAndDropActiveSingle: {
        ru: 'Перенесите сюда видео, которое хотите загрузить',
        en: 'Drop the video you want to upload here',
    },
    dragAndDropActiveMultiple: {
        ru: 'Перенесите сюда видео, которые хотите загрузить',
        en: 'Drop the videos you want to upload here',
    },
    uploadProgress: {
        ru: 'Загружено {progress}%',
        en: 'Uploaded {progress}%',
    },
    filesAdded: {
        ru: 'Добавлено файлов: {count}',
        en: 'Files added: {count}',
    },
    filesForUpload: {
        ru: 'Файлов для загрузки: {count}',
        en: 'Files to upload: {count}',
    },
    selected: {
        ru: 'Выбрано: {count}',
        en: 'Selected: {count}',
    },
    bulkEditHint: {
        ru: 'изменения в профиле или суммаризации применятся ко всем выбранным',
        en: 'changes in profile or summarization will apply to all selected',
    },
});
